module.exports = __webpack_public_path__ + "media/images/emblems/Giffers-coat_of_arms-793329412e916f9c83675fb5b5976447.svg";